import React from "react";

export const TierBadge: React.FC<{ tier: string; className?: string }> = ({ tier, className = "" }) => {
  const map: Record<string, string> = {
    Bronce: "from-[#7A4519] to-[#9A5B24] text-white border-[#9A5B24]",
    Plata: "from-[#4B5563] to-[#64748B] text-white border-[#64748B]",
    Oro: "from-[#C9971E] via-[#E0A82E] to-[#F6D77A] text-[#2a2103] border-[#E0A82E]",
    VIP: "from-[#123884] to-[#123884] text-white border-[#BDCDE6]",
  };
  return (
    <span
      data-testid="customer-tier-badge"
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider bg-gradient-to-r border ${map[tier] || map.Bronce} ${className}`}
    >
      {tier}
    </span>
  );
};

export const StatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const map: Record<string, string> = {
    active: "bg-emerald-500/15 text-emerald-700 border-emerald-500/30",
    overdue: "bg-amber-500/15 text-amber-700 border-amber-500/30",
    inactive: "bg-red-500/15 text-red-700 border-red-500/30",
    pendiente: "bg-amber-500/15 text-amber-700 border-amber-500/30",
    aprobado: "bg-emerald-500/15 text-emerald-700 border-emerald-500/30",
    entregado: "bg-blue-500/15 text-blue-700 border-blue-500/30",
    rechazado: "bg-red-500/15 text-red-700 border-red-500/30",
    pending: "bg-amber-500/15 text-amber-700 border-amber-500/30",
    approved: "bg-emerald-500/15 text-emerald-700 border-emerald-500/30",
    rejected: "bg-red-500/15 text-red-700 border-red-500/30",
  };
  const labels: Record<string, string> = {
    active: "Al día",
    overdue: "No al día",
    inactive: "Inhabilitado",
    pendiente: "Pendiente",
    aprobado: "Aprobado",
    entregado: "Entregado",
    rechazado: "Rechazado",
    pending: "Por aprobar",
    approved: "Aprobado",
    rejected: "Rechazado",
  };
  const icon: Record<string, string> = { overdue: "!", inactive: "✕", rejected: "✕", rechazado: "✕", pending: "…", pendiente: "…" };
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border ${map[status] || map.active}`}>
      {icon[status] && <span aria-hidden="true">{icon[status]}</span>}
      {labels[status] || "Sin estado"}
    </span>
  );
};
